export const ticketRuleTypes = [
    {
        label: 'Time slot',
        value: 0,
    },
    {
        label: 'Fixed discount',
        value: 1,
    },
    {
        label: 'Percent discount',
        value: 2,
    }
]